var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultState } from './state';
import { CREATE_USER_SUCCESS, FETCH_USER_ERROR, FETCH_USER_REQUEST, FETCH_USER_SUCCESS, FETCH_USER_UNAUTHORIZED, RESET_USER_REQUEST, UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST, UPDATE_USER_SUCCESS, } from './actionTypes';
var reducer = function (state, action) {
    if (state === void 0) { state = defaultState; }
    switch (action.type) {
        case UPDATE_USER_DEFAULT_SHIPPING_ADDRESS_REQUEST:
            var user = state.item.item;
            if (!user) {
                return __assign({}, state);
            }
            user.default_shipping_address = action.item;
            user.default_shipping_address_id = action.item.id;
            return __assign(__assign({}, state), { item: { status: 'loaded', item: user } });
        case RESET_USER_REQUEST:
            return __assign(__assign({}, state), { item: { status: 'unloaded', item: null } });
        case CREATE_USER_SUCCESS:
            return __assign(__assign({}, state), { item: { status: 'loaded', item: action.item } });
        case FETCH_USER_REQUEST:
            return __assign(__assign({}, state), { item: { status: 'loading', item: null } });
        case FETCH_USER_SUCCESS:
            return __assign(__assign({}, state), { item: { status: 'loaded', item: action.item } });
        case FETCH_USER_ERROR:
            return __assign(__assign({}, state), { item: { status: 'error', item: null } });
        case FETCH_USER_UNAUTHORIZED:
            return __assign(__assign({}, state), { item: { status: 'unauthorized', item: null } });
        case UPDATE_USER_SUCCESS:
            return __assign(__assign({}, state), { item: { status: 'loaded', item: action.item } });
        // case RESET_OTP:
        //     return { ...state, otp: { status: 'unloaded' } }
        //
        // case REQUEST_OTP_REQUEST:
        //     return { ...state, otp: { status: 'loading' } }
        //
        // case REQUEST_OTP_SUCCESS:
        //     return { ...state, otp: { status: 'loaded' } }
        //
        // case REQUEST_OTP_ERROR:
        //     return { ...state, otp: { status: 'error' } }
        //
        // case CREATE_ANONYMOUS_USER_REQUEST:
        //     return { ...state, anonymousUser: { status: 'loading' } }
        //
        // case CREATE_ANONYMOUS_USER_SUCCESS:
        //     return { ...state, anonymousUser: { status: 'loaded' } }
        //
        // case CREATE_ANONYMOUS_USER_ERROR:
        //     return { ...state, anonymousUser: { status: 'error' } }
        //
        // case REQUEST_OTP_FORBIDDEN:
        //     return { ...state, otp: { status: 'forbidden' } }
    }
    return state;
};
export default reducer;
